import api from "src/api/index";
import {STATE_MEDIA} from "../config";

export async function sendOrderUserUpdate(id){
    const response =  await api.post(STATE_MEDIA + `api/dashboard/users/orders/${id}`)
    return response.status
}
